import { TableRow } from '@mui/material';
import styled from 'styled-components';
import { COLORS, SHADOWS } from './constants';

export const StyledTableRow = styled(TableRow)<{
  $isBlocked?: boolean;
  $hasDateChanged?: boolean;
  $dateChangeAccepted?: boolean;
  $isSelected?: boolean;
  $isDeleted?: boolean;
  $isshippingLineHaulage?: boolean;
}>`
  position: relative;
  contain: layout style;
  font-size: 0.7rem;

  ${({ $isshippingLineHaulage }) =>
    $isshippingLineHaulage &&
    `
    background-color: ${COLORS.shippingLineHaulageBg};
    & td {
      background-color: ${COLORS.shippingLineHaulageBg};
      border-top: none !important;
      border-left: none !important;
      border-right: none !important;
      border-bottom: 1px solid ${COLORS.borderGray} !important;
    }
  `}

  ${({ $isSelected }) =>
    $isSelected &&
    `
    background-color: ${COLORS.selected};
    
    &:hover {
      background-color: ${COLORS.selectedHover};
    }
  `}

  ${({ $isBlocked }) =>
    $isBlocked &&
    `
    background-color: ${COLORS.blocked};
    pointer-events: none;
    
    & td {
      border-color: rgba(158, 158, 158, 0.3);
      color: rgba(0, 0, 0, 0.22);
    }
  `}

  ${({ $isshippingLineHaulage, $hasDateChanged, $isDeleted }) =>
    $isshippingLineHaulage &&
    !$hasDateChanged &&
    !$isDeleted &&
    `
    background-color: ${COLORS.shippingLineHaulageBg};
    font-style: italic;

    & td {
      background-color: ${COLORS.shippingLineHaulageBg};
    }

    &:hover {
      background-color: ${COLORS.shippingLineHaulageHover};

      & td {
        background-color: ${COLORS.shippingLineHaulageHover};
      }
    }
  `}

  ${({ $hasDateChanged, $dateChangeAccepted }) =>
    $hasDateChanged &&
    `
    background-color: ${
      $dateChangeAccepted ? COLORS.dateChangedAcceptedBg : COLORS.dateChangedBg
    };
    
    & td {
      background-color: ${
        $dateChangeAccepted
          ? COLORS.dateChangedAcceptedBg
          : COLORS.dateChangedBg
      };
      border-top: none !important;
      border-left: none !important;
      border-right: none !important;
      border-bottom: 1px solid ${COLORS.borderGray} !important;
    }

    &:hover {
      background-color: ${
        $dateChangeAccepted
          ? COLORS.dateChangedAcceptedBgHover
          : COLORS.dateChangedHover
      };
      
      & td {
        background-color: ${
          $dateChangeAccepted
            ? COLORS.dateChangedAcceptedBgHover
            : COLORS.dateChangedHover
        };
        border-top: none !important;
        border-left: none !important;
        border-right: none !important;
        border-bottom: 1px solid ${COLORS.borderGray} !important;
      }
    }
  `}

  ${({ $isDeleted }) =>
    $isDeleted &&
    `
    background-color: ${COLORS.deleted};
    pointer-events: none;
    opacity: 0.6;
    
    & td {
      background-color: ${COLORS.deletedCell};
      color: rgba(0, 0, 0, 0.4);
      text-decoration: line-through;
    }

    &:hover {
      background-color: ${COLORS.deleted};
      
      & td {
        background-color: ${COLORS.deletedCell};
      }
    }
  `}

  &:hover {
    background-color: ${({
      $isBlocked,
      $hasDateChanged,
      $dateChangeAccepted,
      $isSelected,
      $isDeleted,
      $isshippingLineHaulage,
    }) =>
      $isDeleted
        ? COLORS.deleted
        : $isBlocked
        ? 'rgba(158, 158, 158, 0.15)'
        : $hasDateChanged
        ? $dateChangeAccepted
          ? COLORS.dateChangedAcceptedBgHover
          : '#ffcc80'
        : $isshippingLineHaulage
        ? COLORS.shippingLineHaulageHover
        : $isSelected
        ? COLORS.selectedHover
        : $isshippingLineHaulage
        ? COLORS.shippingLineHaulageHover
        : COLORS.rowHover};
  }

  & td {
    height: 100%;
  }
`;

export const WarningIconWrapper = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const WarningIcon = styled.div<{
  $bgColor: string;
  $hoverBgColor: string;
}>`
  position: sticky;
  right: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.$bgColor};
  border-radius: 50%;
  padding: 4px;
  cursor: help;
  box-shadow: ${SHADOWS.icon};
  min-height: 14px;
  pointer-events: auto;

  .MuiSvgIcon-root {
    color: ${COLORS.white};
    font-size: 10px;
  }

  &:hover {
    background: ${(props) => props.$hoverBgColor};
  }
`;
